// extracted by mini-css-extract-plugin
export default {"modal":"CustomModal_modal__asgss","title":"CustomModal_title__3E5t6","close":"CustomModal_close__A3M+H","action":"CustomModal_action__2Ep9A"};